<template>
  <section class="mb-0">
    <div class="rounded-0 px-md-5 text-center pt-lg-3 pt-sm-3 hero-bg">
      <!--style="background-image: url(https://www.static-immobilienscout24.de/fro/homepage/header-visuals/optimistic_woman_with_window_newbrand.png);object-fit: fit;">-->
      <div class="align-items-center px-0 px-sm-5 mx-auto pb-sm-3 pt-3">
        <h1 class="h1 bg-light text-dark text-center d-inline-block px-4">Wir kaufen deine Küche</h1><br>
        <div class="my-5 mx-0 mx-sm-3">
          <evaluate />
        </div>
      </div>
    </div>
  </section> 
</template>


<script>
import evaluate from "@/components/evaluate.vue"

export default {
  name: 'navbar',
  components: {
    evaluate
  },
  data: function () { 
    return {};
  },
  computed: {
  },
  created: function () {
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>

<style scoped>
@media (min-width: 576px) {
  .hero-bg {
    background: linear-gradient(to left, rgba(10,10,50,0.2), rgba(10,10,50,0.2)), url("/img/myDesigns/pictures/kitchen.jpg"); 
    background-position: center; 
    background-repeat: no-repeat; 
    background-size: cover; 
  }
}
</style>